var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.84301 0C2.60624 0 0 2.60624 0 5.84301V26.157C0 29.3938 2.60624 32 5.84301 32H16.853V19.49H13.545V14.986H16.853V11.138C16.853 8.11482 18.8076 5.33901 23.31 5.33901C25.133 5.33901 26.481 5.51402 26.481 5.51402L26.375 9.72003C26.375 9.72003 25.0002 9.70704 23.5 9.70704C21.8764 9.70704 21.616 10.4551 21.616 11.6971V14.986H26.504L26.291 19.49H21.616V32.0001H26.157C29.3938 32.0001 32 29.3938 32 26.1571V5.84304C32 2.60627 29.3938 3.2e-05 26.157 3.2e-05L5.84301 0Z",
    fill: "#4267B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default __webpack_public_path__ + "static/media/Facebook Logo.fe7a31cbcac55e50d2881e9ef24a8ec6.svg";
export { ForwardRef as ReactComponent };